import Carousel from 'emerald-ui/lib/Carousel';
import populateDocs from './utils/populateDocs';

export default {
  ...populateDocs([{ component: Carousel, componentName: 'Carousel' }], 'Carousel'),
  description: 'Shows a series of pieces of content or images in a slider making only one visible at a time.',
  codeSamples: [
    {
      title: 'Default',
      scope: { Carousel },
      code: `<Carousel innerMargin={20}>
  <Carousel.Slide style={{ width: '30vw' }}>
    This is the first slide
  </Carousel.Slide>
  <Carousel.Slide style={{ width: '30vw' }}>
    This is the second slide
  </Carousel.Slide>
  <Carousel.Slide style={{ width: '30vw' }}>
    This is the third slide
  </Carousel.Slide>
</Carousel>`,
    },
  ],
};
